// @todo revisit when we know more about how this all works
var CheckoutStatus;
(function (CheckoutStatus) {
    CheckoutStatus["CREATING_RECOGNITION"] = "creating_recognition";
    CheckoutStatus["FAILED"] = "failed";
    CheckoutStatus["ONGOING"] = "ongoing";
    CheckoutStatus["PAYMENT_ERROR"] = "payment_error";
    CheckoutStatus["PAYMENT_FORM_SUBMIT"] = "payment_form_submit";
    CheckoutStatus["PAYMENT_FORM_VALIDATION_ERROR"] = "validation_error";
    CheckoutStatus["SUCCESS"] = "success";
    CheckoutStatus["UPDATING_RECOGNITION"] = "updating_recognition";
})(CheckoutStatus || (CheckoutStatus = {}));
export default CheckoutStatus;
